import React from 'react';
import {
	Form, Empty, Checkbox, Button, message, Col, Row, Input, Select, DatePicker, Space, Card, Radio, Spin,
	InputNumber, Descriptions, Modal, Dropdown, Menu
} from 'antd';
import { PushpinOutlined, CalendarOutlined, PlusOutlined, 
	CloseOutlined, DownCircleOutlined, CloudDownloadOutlined 
} from '@ant-design/icons';
import { APIService } from '../../../../services/projectManager/api';
import { CalendarTimeService } from '../../../../services/calendar/calendar.tool.service.js';
import UploadComponent from './UploadComponent.jsx';
import {returnIframeUrl} from "../../../../lib/http";
import { __waterDocumentSvg } from '../../../../lib/waterMarking.js';
import {PMAPI,PMENUM} from '../../../../lib/postmsg';
import reactDialog from '../../../../lib/editableDialog';
import ShowRecord from '../../showRecord/ShowRecord.jsx';
import approveCommonet from '../../showRecord/approve-commonet.js';
import Replacement from '../../../../components/customPage/project-manager/Pages/Replacement.jsx'
import 'antd/dist/antd.css';
import moment from 'moment';
import 'moment/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';
import './BaseInfo.scss'

class UseInfo extends React.Component{
	
	constructor(props) {
		super(props);

		this.state = {};
	}

	componentDidMount() {
		const userInfo = window.config.sysConfig ? window.config.sysConfig.userInfo : window.config;
		__waterDocumentSvg({
			container : document.getElementById('investment-page_panel-use-info'),
			// content : `${userInfo.user_department} ${userInfo.username} ${CalendarTimeService.getDayDate()}`,
			content : `${userInfo.user_department} ${userInfo.name} ${CalendarTimeService.getDayDate()}`,
			width : '700px',
			height : '550px',
			opacity : '0.1',
			fontSize : '26px',
			zIndex : 1000
		})
	}

	componentWillUnmount(){
	    this.setState = (state,callback) =>{
	      return;
	    };
	}

	/**
	 * [下载使用须知]
	 * @return {[type]} [description]
	 */
	downloadExcel = () => {
		let param = {
			table_id: '1787_UkqEFbU7XYdNQabzuEbW34',
			isFilter: false,
			custom: "true",
			is_group: 0,
			attachment: true,
		}
		let url = returnIframeUrl('/export/', param);
        let aElement = document.createElement('a'); //创建节点
        document.body.appendChild(aElement);
        aElement.style.display = 'none';
        aElement.href = url;
        aElement.click();
        document.body.removeChild(aElement);
	};

	render(){
		const { data } = this.props.data;
		return (
			<div id="investment-page_panel-use-info">
				<Card
					extra={
						<Button 
							type="primary"
							onClick={this.downloadExcel}
						>
							全部下载
							<CloudDownloadOutlined />
						</Button>
					}
				>
					<table >
						<thead>
							<tr>
								<td>文件名称</td>
								<td>内容描述</td>
								<td>文件要求</td>
								<td>样本</td>
							</tr>
						</thead>
						<tbody>
							{data.map((row, index) => (
								<tr key={index}>
									<td>{row['文件名称']}</td>
									<td>{row['内容描述']}</td>
									<td>{row['文件要求']}</td>
									<td>
										{row['样本'].map((f, index) => (
											<a 
												key={`file_${index}`} 
												href={`${returnIframeUrl('/download_attachment/?file_id='+ f.file_id +'&download=1')}`}
											>{f['name']}</a>
										))}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</Card>
			</div>
		)
	}
}

class PagePanel extends React.Component{

	constructor(props) {
		super(props);

		this.state = {
			loading: false,
			submitLoading: false,
			data: [
			],
			formData: {},
			cache_old: {},
			commont: '',
			action: 0,
			isEdit: this.props.data.isEdit,
			record_info: {},
			department_list:[]
		};

		this.formRef = React.createRef();
	}

	componentDidMount() {
		console.log('window', window)
		const userInfo = window.config.sysConfig ? window.config.sysConfig.userInfo : window.config;
		__waterDocumentSvg({
		    container : document.getElementById('investment-page_panel'),
		    // content : `${userInfo.user_department} ${userInfo.username} ${CalendarTimeService.getDayDate()}`,
			content : `${userInfo.user_department} ${userInfo.name} ${CalendarTimeService.getDayDate()}`,
		    width : '700px',
		    height : '550px',
		    opacity : '0.1',
		    fontSize : '26px',
		    zIndex : 1000
		})
		this.getInvestmentConsultant();
		this.getInstructions();
		this.GetInvestmentAdviserDepartment()
	}

	componentWillUnmount(){
	    this.setState = (state,callback) =>{
	      return;
	    };
	}

	GetInvestmentAdviserDepartment = () => {
		APIService.getInvestmentAdviserDepartment().then(res => {
			if(res.success){
				if( this.props.data.creation && res.is_investment !== "") {
					res.data.map((item,index) => {
						if (item.label == res.is_investment){
							this.formRef.current.setFieldsValue({"f49":item.value})
						} 
					})
				}
				this.setState({department_list:res.data})
			}else{
				console.log(`获取投资顾问部门信息失败,Error:${res.error}`)
			}
		}).catch(err => {
			console.log('获取投资顾问部门信息失败 Error', err)
		})
	}

	getInvestmentConsultant = () => {
		this.setState((prev, props) => {
			return {loading: true}
		})
		const { record_id, rowId } = this.props.data;
		let param = {
			record_id: record_id,
			row_id: rowId
		}
		APIService.GetInvestmentConsultant(param).then(res => {
			if(res.success){
				let formData = {}, cache_old = {}
				const date_list = ['f11', 'f20', 'f22'];
				const file_fields = ['f29', 'f30', 'f31', 'f32', 'f33', 'f34', 'f35', 'f36', 'f37', 'f38', 'f39', 'f40',
					'f41', 'f42', 'f43', 'f44', 'f45', 'f46', 'f47'
				];
				Object.keys(res.data).map(field => {
					if(res.data[field]){
						if(date_list.includes(field)){
							formData[field] = moment(res.data[field], 'YYYY-MM-DD');
						}else{
							formData[field] = res.data[field];
						}

						if(file_fields.includes(field)){
							var temp = [];
							res.data[field].map(row => {
								temp.push(row.file_id)
							})
							cache_old[field] = temp
						}else{
							cache_old[field] = res.data[field];
						}
					}
				})
				this.setState((prev, props) => {
					return { loading: false, formData: formData, cache_old: cache_old, record_info: res.record_info }
				}, () => this.formRef.current.setFieldsValue(formData))
			}else{
				console.log(`获取投资顾问信息失败,Error:${res.error}`)
				this.setState((prev, props) => {
					return { loading: false}
				})
			}
		}).catch(err => {
			console.log('获取投资顾问信息失败 Error', err)
		})
	};

	getInstructions = () => {
		APIService.GetInstructions({}).then(res => {
			if(res.success){
				this.setState((prev, props) => {
					return { data: res.rows }
				})
			}
		}).catch(err => {
			conosle.log('获取使用须知数据 Error', err)
		})
	};

	onFinish = ( fieldsValue ) => {
		console.log('fieldsValue', fieldsValue)
		const { type } = this.props.data;
		this.setState((prev, props) => {
			return { loading: true, submitLoading: true }
		})
		const file_fields = ['f29', 'f30', 'f31', 'f32', 'f33', 'f34', 'f35', 'f36', 'f37', 'f38', 'f39', 'f40',
			'f41', 'f42', 'f43', 'f44', 'f45', 'f46', 'f47'
		];
		const date_fields = ['f11', 'f20', 'f22']
		let values = {}
		Object.keys(fieldsValue).map(field => {
			if(fieldsValue[field] != undefined){
				if(file_fields.includes(field)){
					var file_ids = [];
					fieldsValue[field].map(row => {
						if(row['response']){
							file_ids.push(row['response']['file_id'])
						}else{
							file_ids.push(row['file_id'])
						}
					})
					values[field] = file_ids;
				}else if(date_fields.includes(field)){
					values[field] = fieldsValue[field].format('YYYY-MM-DD')
				}else{
					values[field] = fieldsValue[field];
				}
			}else {
				values[field] = "";
			}
		})
		console.log('submit', values)
		if(type == 'approve'){
			const { record_id, flow_id } = this.props.data;
			const { cache_old, commont, action } = this.state;
 			let param = {
				record_id: record_id,
				flow_id: flow_id,
				flow_name: '投资顾问申请流程',
				action: action,
				comment: commont,
				data: JSON.stringify(values),
				cache_old: JSON.stringify(cache_old),
				cache_new: JSON.stringify(values),
				table_id:"3758_gZzndkxkm8ndk6FBcQymy4"
			}
			APIService.ApproveWorkflow(param).then(res => {
				if(res.success){
					message.success('审批成功');
					this.props.onClose();
				}else{
					message.error(res.error);
					this.setState((prev, props) => {
						return {loading: false, submitLoading: false}
					})
				}
			}).catch(err => {
				console.log('审批投资顾问流程 Error', err);
				this.setState((prev, props) => {
					return {loading: false, submitLoading: false}
				})
			})
		}else{
			const { cache_old , department_list } = this.state;

			let newValues = JSON.parse(JSON.stringify(values))

			department_list.map((item,index) => {
				if (item.value == cache_old["f49"]){
					cache_old["f49"] = item.label
				} 
				if (item.value == newValues["f49"]){
					newValues["f49"] = item.label
				} 
			})

			let param = {
				flow_name: '投资顾问申请流程',
				form_data: JSON.stringify(values),
				record_info: JSON.stringify(this.state.record_info),
				cache_old: JSON.stringify(cache_old),
				cache_new: JSON.stringify(newValues),
			}
			APIService.FastCreateWorkflow(param).then(res => {
				if(res.success){
					message.success('投资顾问信息提交成功');
					this.props.onClose();
				}else{
					message.error(`投资顾问信息提交失败, Error:${res.error}`)
				}
				this.setState((prev, props) => {
					return { loading: false, submitLoading: false }
				})
			}).catch(err => {
				console.log('创建投资顾问的信息Error', err)
				if(err.status == 500){
					message.error('服务器错误,信息提交失败!')
				}
				this.setState((prev, props) => {
					return { loading: false, submitLoading: false }
				})
			})
		}
	};

	/**
	 * [普通提交方法]
	 * @return {[type]} [description]
	 */
	submit = () => {
		this.formRef.current.submit()
	};

	normFile = (e) => {
		if (Array.isArray(e)) {
			return e;
		}
		return e && e.fileList;
	};

	/**
	 * [审批方法]
	 * @return {[type]} [description]
	 */
	approve = () => {
        let t = window.devicePixelRatio
		var that = this;
		PMAPI.openDialogToSelfByComponent(approveCommonet, {
            // width: window.innerWidth,
            // height: window.innerHeight,
			width:800,
			height: 500,
            title: '审批流程',
	        iszoom:true,
			special:true,
		}).then((data) => {
			console.log('approve', data)
			if(!data.onlyclose && data.type == 'submit'){
				that.setState((prev, props) => {
					return { action: 0, commont: data.commont}
				}, () => that.formRef.current.submit())
			}
		})
	};

	reject = (opa) => {
        let t = window.devicePixelRatio
		var that = this;
		var action = opa;
		var title = opa == 2? '驳回到发起人': '驳回到上一节点';
		PMAPI.openDialogToSelfByComponent(approveCommonet, {
            // width: window.innerWidth*t,
            // height: window.innerHeight*t,
			width:800,
			height: 500,
            title: `流程 ${title}`,
			iszoom:true,
			special:true,
		}).then((data) => {
			console.log('approve', data)
			if(!data.onlyclose && data.type == 'submit'){
				that.setState((prev, props) => {
					return { action: action, commont: data.commont}
				}, () => that.formRef.current.submit())
			}
		})
		// this.setState((prev, props) => {
		// 	return { action: opa, commont: ''}
		// }, () => this.formRef.current.submit())
	};

	changeEdit = () => {
		const { record } = this.props

		if(record.status == 2 ){
			message.warning('该项目流程还在审批中,不可编辑');
			return
		}else {
			this.setState((prev, props) => {
				return {isEdit:true}
			})
		}
	};

	formatNumber = (num, point = 0) => {
		if (num) {
			num = `${parseFloat(num).toFixed(point)}`
			let num_list = num.split('.')
			if (num_list.length == 2) {
				return `${num_list[0].replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,')}.${num_list[1]}`;
			} else {
				return num_list[0].replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,')
			}
		} else {
			return ''
		}
	};

	render(){
		const { formData, showRecord, record_id, type, isFrom, viewMode  } = this.props.data;
		const { loading, data, submitLoading, isEdit } = this.state;
		console.log('isEdit', isEdit)

		console.log(this.state.department_list,"department_list")
		console.log(this.props.record)
		return(
			<div id="investment-page_panel" style={{fontFamily:'Microsoft YaHei,PingFang SC'}}>
				<Spin
					size="large"
					spinning={loading}
				>
					<Form
						ref={this.formRef}
						name='base'
						labelAlign="left"
						layout="inline"
						initialValues={formData}
						onFinish={this.onFinish}
					>
						<Card
							title="基础信息"
							style={{width:'100%'}}
							extra={
								type=='approve'?
								<Space>
									<Button
										className="UnifiedButton"
										type="primary"
										onClick={this.approve}
										loading={submitLoading}
									>
										审批
									</Button>
									<Dropdown
										overlay={
											<Menu>
												<Menu.Item key="1" onClick={() => this.reject(2)}>
													驳回到发起人
												</Menu.Item>
												<Menu.Item key="2" onClick={() => this.reject(1)}>
													驳回上一节点
												</Menu.Item>
											</Menu>
										}
										getPopupContainer={triggerNode => triggerNode.parentElement}
										arrow={true}
										trigger={['click']}
									>
										<Button
											type="primary"
											loading={submitLoading}
											className="UnifiedButton"
										>
											驳回
											<DownCircleOutlined />
										</Button>
									</Dropdown>
								</Space>:
								isFrom=='workflow'?"":
								viewMode=="in_process"?"":
								isEdit?
								<Button 
									type="primary" onClick={this.submit} loading={submitLoading}
									disabled={!isEdit}
									style={{background:'#d60011',borderColor:'#d60011'}}
								>
									提交
								</Button>:
								<Button 
									type="primary" onClick={this.changeEdit} loading={submitLoading}
								>
									转到编辑
								</Button>
							}
						>
							<Descriptions
								size="middle"
								bordered
								column={2}
							>
								<Descriptions.Item
									className="label_name"
									label={<span>机构名称<font style={{color:'red', fontSize: 18}}>*</font></span>}
									span={2}
								>	
									<Form.Item name="_id" hidden={true}><Input /></Form.Item>
									<Form.Item name="f50" hidden={true}><Input /></Form.Item>
									<Form.Item
										name="f5"
										rules={[
											{
												required: true,
												message: '请填写机构名称!',
											},
										]}
									>
										<Input disabled={!isEdit}/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
								className="label_name"
									label={<span>机构简称<font style={{color:'red', fontSize: 18}}>*</font></span>}
									span={2}
								>	
									<Form.Item
										name="f48"
										rules={[
											{
												required: true,
												message: '请填写机构简称!',
											},
										]}
									>
										<Input disabled={!isEdit}/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									className="label_name"
									label="机构成立日期"
								>
									<Form.Item
										name="f11"
                                        className='query_cycle'
									>
										<DatePicker 
                                            style={{width:'100%'}} 
                                            disabled={!isEdit} 
                                            locale={locale}
                                            getPopupContainer={triggerNode => triggerNode.parentNode}
                                        />
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="注册资本（万元）"
									className="label_name"
								>
									<Form.Item
										name="f12"
									>
										<InputNumber 
											style={{width:'100%'}} 
											disabled={!isEdit}
											formatter={value => `${this.formatNumber(value)}`}
										/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="实收资本（万元）"
									className="label_name"
								>
									<Form.Item
										name="f13"
									>
										<InputNumber 
											style={{width:'100%'}} 
											disabled={!isEdit}
											formatter={value => `${this.formatNumber(value)}`}
										/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="法定代表人"
									className="label_name"
								>
									<Form.Item
										name="f14"
									>
										<Input disabled={!isEdit}/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="联系人"
									className="label_name"
								>
									<Form.Item
										name="f15"
									>
										<Input disabled={!isEdit}/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="联系电话"
									className="label_name"
								>
									<Form.Item
										name="f16"
									>
										<Input disabled={!isEdit}/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="投资经理"
									className="label_name"
								>
									<Form.Item
										name="f23"
									>
										<Input disabled={!isEdit}/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="是否协会备案的私募基金管理人"
									className="label_name"
								>
									<Form.Item
										name="f19"
									>
										<Radio.Group buttonStyle="solid" disabled={!isEdit}>
											<Radio.Button value="是">是</Radio.Button>
											<Radio.Button value="否">否</Radio.Button>
										</Radio.Group>
										{/* {
											isEdit && <Replacement formRef={this.props.formRef} subscript={"f19"}/>
										} */}
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="备案时间"
									className="label_name"
                                   
								>
									<Form.Item
										name="f20"
                                        className='query_cycle'
									>
										<DatePicker 
                                        style={{width:'100%'}} 
                                        disabled={!isEdit} 
                                        locale={locale}
                                        // getPopupContainer={triggerNode => triggerNode.parentNode}
                                        />
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="是否满足协会规定的投资顾问标准"
									className="label_name"
								>
									<Form.Item
										name="f21"
									>
										<Radio.Group buttonStyle="solid" disabled={!isEdit}>
											<Radio.Button value="是">是</Radio.Button>
											<Radio.Button value="否">否</Radio.Button>
										</Radio.Group>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="协会投资顾问认证时间"
									className="label_name"
								>
									<Form.Item
										name="f22"
                                        className='query_cycle'
									>
										<DatePicker 
                                            style={{width:'100%'}} 
                                            disabled={!isEdit}
                                            locale={locale}
                                            // getPopupContainer={triggerNode => triggerNode.parentNode}
                                        />
									</Form.Item>
								</Descriptions.Item>
								
								<Descriptions.Item
									label="其他核心投资人员"
									className="label_name"
								>
									<Form.Item
										name="f24"
									>
										<Input disabled={!isEdit}/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="尽调频率（月）"
									className="label_name"
								>
									<Form.Item
										name="f26"
									>
										<InputNumber 
											style={{width:'100%'}} disabled={!isEdit} min={0}
											precision={0}
										/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="通讯地址"
									className="label_name"
								>
									<Form.Item
										name="f18"
									>
										<Input disabled={!isEdit}/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="注册地址"
									className="label_name"
									span={2}
								>
									<Form.Item
										name="f17"
									>
										<Input disabled={!isEdit}/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="投资顾问部门"
									className="label_name"
									span={2}
								>
									<Form.Item
										name="f49"
									>
										<Select disabled={!isEdit} allowClear={true}>
											{
												this.state.department_list.map((item,index) => {
													return <Select.Option key={index} value={item.value}>{item.label}</Select.Option>
												}) 
											}
										</Select>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="投资顾问介绍"
									className="label_name"
									span={2}
								>
									<Form.Item
										name="f28"
									>
										<Input.TextArea style={{width:'100%'}} disabled={!isEdit}/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="备注"
									className="label_name"
									span={2}
								>
									<Form.Item
										name="f27"
									>
										<Input.TextArea style={{width:'100%'}} disabled={!isEdit}/>
									</Form.Item>
								</Descriptions.Item>
							</Descriptions>
						</Card>
						<Card
							title="附件信息"
							style={{width:'100%'}}
							extra={
								<Button 
									className="UnifiedButton"
									type="primary" 
									shape="round" 
									size="large"
									onClick={() => {
										reactDialog.show({
											el: UseInfo,
											className: 'UseInfo',
											title: '尽调材料说明',
											data: data ,
        									iszoom:true,
											modality:true,
										})
									}}
								>
                                    尽调材料说明
								</Button>
							}
						>
							<Descriptions
								size="middle"
								bordered
								column={2}
								labelStyle={{width: 280}}
							>
								<Descriptions.Item
									label="投资顾问介绍"
								>
									<Form.Item
										name="f29"
										valuePropName="fileList"
										getValueFromEvent={this.normFile}
									>
										<UploadComponent  disabled={!isEdit} key="f29"/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="承诺函"
								>
									<Form.Item
										name="f30"
										valuePropName="fileList"
										getValueFromEvent={this.normFile}
									>
										<UploadComponent  disabled={!isEdit} key="f30"/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="营业执照复印件"
								>
									<Form.Item
										name="f31"
										valuePropName="fileList"
										getValueFromEvent={this.normFile}
									>
										<UploadComponent  disabled={!isEdit} key="f31"/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="公司章程复印件"
								>
									<Form.Item
										name="f32"
										valuePropName="fileList"
										getValueFromEvent={this.normFile}
									>
										<UploadComponent  disabled={!isEdit} key="f32"/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="法人身份证复印件"
								>
									<Form.Item
										name="f33"
										valuePropName="fileList"
										getValueFromEvent={this.normFile}
									>
										<UploadComponent  disabled={!isEdit} key="f33"/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="验资报告"
								>
									<Form.Item
										name="f34"
										valuePropName="fileList"
										getValueFromEvent={this.normFile}
									>
										<UploadComponent  disabled={!isEdit} key="f34"/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="审核报告"
								>
									<Form.Item
										name="f35"
										valuePropName="fileList"
										getValueFromEvent={this.normFile}
									>
										<UploadComponent  disabled={!isEdit} key="f35"/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="财务报告"
								>
									<Form.Item
										name="f36"
										valuePropName="fileList"
										getValueFromEvent={this.normFile}
									>
										<UploadComponent  disabled={!isEdit} key="f36"/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="协会备案信息"
								>
									<Form.Item
										name="f37"
										valuePropName="fileList"
										getValueFromEvent={this.normFile}
									>
										<UploadComponent  disabled={!isEdit} key="f37"/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="内部管理制度"
								>
									<Form.Item
										name="f38"
										valuePropName="fileList"
										getValueFromEvent={this.normFile}
									>
										<UploadComponent  disabled={!isEdit} key="f38"/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="董事会决议"
								>
									<Form.Item
										name="f39"
										valuePropName="fileList"
										getValueFromEvent={this.normFile}
									>
										<UploadComponent  disabled={!isEdit} key="f39"/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="公司荣誉"
								>
									<Form.Item
										name="f40"
										valuePropName="fileList"
										getValueFromEvent={this.normFile}
									>
										<UploadComponent  disabled={!isEdit} key="f40"/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="办公场所证明"
								>
									<Form.Item
										name="f41"
										valuePropName="fileList"
										getValueFromEvent={this.normFile}
									>
										<UploadComponent  disabled={!isEdit} key="f41"/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="基金经理介绍"
								>
									<Form.Item
										name="f42"
										valuePropName="fileList"
										getValueFromEvent={this.normFile}
									>
										<UploadComponent  disabled={!isEdit} key="f42"/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="证券从业证明文件"
								>
									<Form.Item
										name="f43"
										valuePropName="fileList"
										getValueFromEvent={this.normFile}
									>
										<UploadComponent  disabled={!isEdit} key="f43"/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="期货从业证明文件"
								>
									<Form.Item
										name="f44"
										valuePropName="fileList"
										getValueFromEvent={this.normFile}
									>
										<UploadComponent  disabled={!isEdit} key="f44"/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="基金经理在职证明文件"
								>
									<Form.Item
										name="f45"
										valuePropName="fileList"
										getValueFromEvent={this.normFile}
									>
										<UploadComponent  disabled={!isEdit} key="f45"/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="业绩证明"
								>
									<Form.Item
										name="f46"
										valuePropName="fileList"
										getValueFromEvent={this.normFile}
									>
										<UploadComponent  disabled={!isEdit} key="f46"/>
									</Form.Item>
								</Descriptions.Item>
								<Descriptions.Item
									label="历史业绩和交易数据"
								>
									<Form.Item
										name="f47"
										valuePropName="fileList"
										getValueFromEvent={this.normFile}
									>
										<UploadComponent  disabled={!isEdit} key="f47"/>
									</Form.Item>
								</Descriptions.Item>
							</Descriptions>
						</Card>
					</Form>
				</Spin>
				{
					showRecord &&
					<ShowRecord record_id={record_id}/>
				}
			</div>
		)
	}
}

export default PagePanel;


// WEBPACK FOOTER //
// app/components/customPage/investment-advisor/Pages/PagePanel.jsx